// Centralize all language-related configuration
export const LANGUAGES = {
    en: { name: 'English', nativeName: 'English' },
    es: { name: 'Spanish', nativeName: 'Español' },
    fr: { name: 'French', nativeName: 'Français' },
    hi: { name: 'Hindi', nativeName: 'हिन्दी' },
    bn: { name: 'Bengali', nativeName: 'বাংলা' },
    te: { name: 'Telugu', nativeName: 'తెలుగు' },
    mr: { name: 'Marathi', nativeName: 'मराठी' },
    ta: { name: 'Tamil', nativeName: 'தமிழ்' }
};

export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = Object.keys(LANGUAGES);

export function getBrowserLanguage() {
    try {
        const browserLang = navigator.language?.split('-')[0];
        return SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : DEFAULT_LANGUAGE;
    } catch (error) {
        console.error('Error getting browser language:', error);
        return DEFAULT_LANGUAGE;
    }
}

export function getStoredLanguage() {
    try {
        const stored = localStorage.getItem('userLanguage');
        return SUPPORTED_LANGUAGES.includes(stored) ? stored : null;
    } catch (error) {
        console.error('Error accessing localStorage:', error);
        return null;
    }
}

export function getInitialLanguage() {
    return getStoredLanguage() || getBrowserLanguage();
} 